// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems__2msuT"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/NavigationItems/NavigationItems.css
// module id = 93
// module chunks = 0